module.exports = __webpack_public_path__ + "img/srten11.0117f2cd.png";